import { render, staticRenderFns } from "./PopupProductsItemInfoDetail.vue?vue&type=template&id=1f5905f0&"
import script from "./PopupProductsItemInfoDetail.vue?vue&type=script&lang=js&"
export * from "./PopupProductsItemInfoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports